import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  ModalOverlay,
  ModalContent,
  Modal,
  Switch,
  // useDisclosure,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingRelativeParticipantCall } from "../../api/lockingRelativeParticipant";
import { formatTableValue } from "./formatTable";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import { memo } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import IconX from "../../assets/images/booking/x-circle.svg";
import {
  InputControl,
  SelectControl,
} from "../../components/form/formControls";
import * as Yup from "yup";
import { useCallback } from "react";
import { formatNumberUS } from "../../utils/utils";
import { formatDateHourDb } from "../../utils/tools";
import { RegisterRelativeStatus } from "./constants";

export default function ServiceFeeManagementStep1Detail({
  lockingId,
  locking,
  setLocking,
  getLocking,
  handleNext,
  handlePrevious,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [month, setMonth] = useState(null);
  const [dayApprove, setDayApprove] = useState(null);
  const [year, setYear] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [lockingRelativeParticipant, setRelativeParticipant] = useState([]);
  const getLockingRelativeParticipant = async (lockingId) => {
    const participants =
      await lockingRelativeParticipantCall.getAttendanceManager(lockingId);

    if (participants?.items) {
      let mappedData = null;
      if (participants?.items) {
        mappedData = participants?.items.map((item) => ({
          employeeId: item?.employeeId || "",
          code: item?.code || "",
          fullName: item?.fullName || "",
          interpretation: item?.interpretation || "",
          fullNameRelative: item?.fullNameRelative || "",
          standardWorkingDays: item?.standardWorkingDays || "0",
          workingDays: item?.workingDays || "0",
          isBrokerDebtCertificate: item?.isBrokerDebtCertificate || false,
          amountHeld: item?.amountHeld || "0",
          status: false,
        }));
      }
      setRelativeParticipant(mappedData);
    }

    if (participants?.month) {
      setMonth(participants?.month);
    }

    if (participants?.year) {
      setYear(participants?.year);
    }

    if (participants?.dateLocking) {
      setDayApprove(participants?.dateLocking);
    }
  };

  useEffect(() => {
    if (lockingId) {
      getLockingRelativeParticipant(lockingId);
    }
  }, [lockingId]);

  const dataTable = {
    headers: [
      {
        label: "Mã NV",
        key: "code",
      },
      {
        label: "Tên nhân viên",
        key: "fullName",
      },
      {
        label: "Chức vụ",
        key: "interpretation",
      },
      {
        label: "CTV",
        key: "fullNameRelative",
      },
      {
        label: "Ngày công chuẩn",
        key: "standardWorkingDays",
      },
      {
        label: "Ngày công",
        key: "workingDays",
      },
      {
        label: "Đã có CCMG",
        key: "isBrokerDebtCertificate",
      },
      {
        label: "Số tiền CCMG tạm giữ",
        key: "amountHeld",
      },
    ],
    data: lockingRelativeParticipant,
  };

  const submitEdit = (type, id, value, key) => {
    // console.log({ type, id, value });
    setDataEdit({ type, id, value, key });
    onOpen();
  };

  function updateParticipantValue({ employeeId, key, value }) {
    console.log({ employeeId, key, value });
    const lockingRelativeParticipantNew = lockingRelativeParticipant.map(
      (item) => {
        if (item.employeeId === employeeId) {
          return {
            ...item,
            [key]: value,
            status: true,
          };
        }
        return item;
      }
    );

    setRelativeParticipant(lockingRelativeParticipantNew);
    onClose();
  }

  const approveLockingRelative = async (lockingId, status = RegisterRelativeStatus.APPROVED) => {
    const toastCreate = toast.loading("Đang cập nhật trạng thái ...");
    const dataFormat = {
      registerRelativeStatus: status,
    };
    try {
      const lockingRelativeParticipantData = lockingRelativeParticipant.map(
        (item) => ({
          employeeId: item?.employeeId,
          workingDays: item?.workingDays || 0,
          isBrokerDebtCertificate: item?.isBrokerDebtCertificate || false,
          amountHeld: item?.amountHeld || 0,
          month,
          year,
        })
      );

      if (lockingRelativeParticipantData?.length > 0) {
        dataFormat.lockingRelativeParticipant = lockingRelativeParticipantData;
      }

      const relativeParticipant = lockingRelativeParticipant.filter(
        (item) => item.status
      );

      let dataRelativeParticipant = null;
      if (relativeParticipant?.length > 0) {
        dataRelativeParticipant = relativeParticipant.map((item) => ({
          employeeId: item?.employeeId,
          workingDays: item?.workingDays || 0,
          isBrokerDebtCertificate: item?.isBrokerDebtCertificate || false,
          amountHeld: item?.amountHeld || 0,
          month,
          year,
        }));
      }

      if (dataRelativeParticipant?.length > 0) {
        dataFormat.dataRelativeParticipant = dataRelativeParticipant;
      }
      const data = await lockingCall.approveRegisterRelative(
        lockingId,
        dataFormat
      );
      if (data) {
        handleNext();
        await getLocking(lockingId);
        toast.success("Cập nhật trạng thái thành công");
      }
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <Box>
      <Box m={"24px 0"} w={"100%"}>
        <Flex justifyContent={"space-between"}>
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            Nhân viên tham gia
          </Text>
          <Flex gap={"32px"}>
            {locking?.registerRelativeStatus ===
              RegisterRelativeStatus.APPROVED && (
              <Flex gap={"8px"}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Thời gian duyệt:
                </Text>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  {locking?.registerRelativeApprovedAt
                    ? formatDateHourDb(locking.registerRelativeApprovedAt)
                    : "-"}
                </Text>
              </Flex>
            )}
            {dayApprove && (
              <Flex gap={"8px"}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Ngày duyệt locking:
                </Text>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  {formatDateHourDb(dayApprove)}
                </Text>
              </Flex>
            )}
          </Flex>
        </Flex>

        <Box background={"var(--fill-avatar)"} mt={"16px"} borderRadius={"8px"}>
          <TableContainer
            w={"100%"}
            maxH="calc(100vh - 350.5px)"
            overflowY="auto"
          >
            <Table w={"100%"} variant="unstyled">
              <Thead
                position="sticky"
                top="0"
                zIndex="1"
                w={"100%"}
                h={"41px"}
                color="white"
                fontWeight="400"
                backgroundColor="#F9FAFD"
                borderBottom={"1px solid var(--bg-line-employee)"}
              >
                <Tr h={{ base: "41px" }}>
                  {dataTable.headers.map((e, index) => {
                    let width = "auto";
                    let textAlign = "auto";
                    if (e.key === "code") {
                      width = "10%";
                      textAlign = "start";
                    } else if (e.key === "fullName") {
                      width = "15%";
                      textAlign = "start";
                    } else if (e.key === "interpretation") {
                      width = "10%";
                      textAlign = "start";
                    } else if (e.key === "fullNameRelative") {
                      width = "15%";
                      textAlign = "start";
                    } else if (e.key === "standardWorkingDays") {
                      width = "10%";
                      textAlign = "start";
                    } else if (e.key === "isBrokerDebtCertificate") {
                      width = "15%";
                      textAlign = "start";
                    } else if (e.key === "workingDays") {
                      width = "15%";
                      textAlign = "start";
                    } else {
                      width = "10%";
                      textAlign = "end";
                    }
                    return (
                      <Td
                        p={"16px 16px 8px 16px"}
                        key={index}
                        border={"none"}
                        color={"#51607B"}
                        fontSize={{ base: "14px" }}
                        w={width}
                      >
                        {/* Căn tiêu đề theo nội dung cột (trái, riêng cột tiền căn phải) */}
                        <Box textAlign={textAlign} fontWeight={"bold"}>{e.label}</Box>
                      </Td>
                    );
                  })}
                </Tr>
              </Thead>
              <Tbody w={"100%"} h={"100%"}>
                {dataTable.data?.length > 0 ? (
                  dataTable.data?.map((e, rowIndex) => {
                    const items = { ...e };

                    delete items.status;
                    delete items.employeeId;
                    const keyValues = Object.keys(items);
                    return (
                      <Tr
                        key={rowIndex}
                        h={"44px"}
                        backgroundColor={
                          rowIndex % 2 === 0
                            ? "var(--color-main)"
                            : "var(--fill-avatar)"
                        }
                      >
                        {keyValues.map((keyvalue, index) => {
                          let width = "auto";
                          let widthText = "100%";
                          let textAlign = "auto";
                          let whiteSpace = "inherit";
                          if (keyvalue === "fullName") {
                            width = "15%";
                            textAlign = "start";
                          } else if (keyvalue === "interpretation") {
                            width = "15%";
                            textAlign = "start";
                          } else if (keyvalue === "fullNameRelative") {
                            width = "15%";
                            textAlign = "start";
                          } else if (keyvalue === "standardWorkingDays") {
                            width = "10%";
                            textAlign = "start";
                          } else if (keyvalue === "isBrokerDebtCertificate") {
                            width = "15%";
                            textAlign = "start";
                          } else if (keyvalue === "workingDays") {
                            width = "15%";
                            textAlign = "start";
                          } else {
                            width = "1%";
                            textAlign = "center";
                            whiteSpace = "inherit";
                          }
                          return (
                            <Td p={"16px 16px 8px 16px"} w={width} key={index}>
                              <Box
                                fontSize={{ base: "14px" }}
                                lineHeight={"19.6px"}
                                textAlign={"start"}
                                fontWeight={500}
                                color={"var(--color-info-employee)"}
                                w={widthText}
                                whiteSpace={whiteSpace}
                                overflow="hidden"
                                textOverflow="ellipsis"
                                display="-webkit-box"
                                sx={{
                                  WebkitLineClamp: "2",
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {keyvalue === "workingDays" ||
                                "isBrokerDebtCertificate" ||
                                "amountHeld"
                                  ? formatTableValue(
                                      e[keyvalue],
                                      keyvalue,
                                      submitEdit,
                                      e.employeeId,
                                      null,
                                      null,
                                      locking?.registerRelativeStatus===RegisterRelativeStatus.APPROVED
                                    )
                                  : formatTableValue(e[keyvalue], keyvalue)}
                              </Box>
                            </Td>
                          );
                        })}
                      </Tr>
                    );
                  })
                ) : (
                  <Tr>
                    <Td
                      colSpan={dataTable.headers.length}
                      textAlign="center"
                      padding={"40px 0"}
                    >
                      Không có dữ liệu
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {locking?.confirmCommissionStatus !== RegisterRelativeStatus.APPROVED ? (
        <Box display="flex" justifyContent="flex-end" p={"24px 0"}>
          <Button
            onClick={() => approveLockingRelative(lockingId)}
            type="submit"
            p={"13px 45px"}
            lineHeight={"18px"}
            fontSize={"15px"}
            fontWeight={600}
            color={"var(--color-main)"}
            borderRadius={"8px"}
            bg={"var(--color-option-employee-hover)"}
            _hover={{
              filter: "brightness(90%)",
            }}
          >
            Duyệt
          </Button>
        </Box>
      ) : (
        <Box display="flex" justifyContent="flex-end" p={"24px 0"}>
          <Flex
            w={"max-content"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={1}
          >
            <Image src={iconApproved} w={"20px"} />
            <Text color={"var(--color-status-employ)"}>Đã được duyệt</Text>
          </Flex>
        </Box>
      )}

      <FormEdit
        isOpen={isOpen}
        onClose={onClose}
        defaultValues={dataEdit}
        onSubmit={updateParticipantValue}
      />
    </Box>
  );
}

const FormEdit = memo(({ isOpen, onClose, onSubmit, defaultValues }) => {
  let schema = Yup.object().shape({});
  if (defaultValues?.type === "NUMBER") {
    schema = Yup.object().shape({
      value: Yup.number()
        .transform((value, originalValue) => {
          if (
            typeof originalValue === "string" &&
            originalValue.trim() === ""
          ) {
            return null;
          }
          return Number(originalValue);
        })
        .typeError("Tổng số quỹ giữ phải là một số hợp lệ")
        // .moreThan(0, "Tổng số quỹ giữ phải lớn hơn 0")
        .required("Vui lòng nhập tổng số quỹ giữ"),
    });
  }
  const CCMGData = [
    {
      value: 1,
      label: "Đã có",
    },
    {
      value: 2,
      label: "Chưa có",
    },
  ];

  const {
    setValue,
    reset,
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues?.value
      ? {
          value:
            defaultValues?.type === "CHECKED"
              ? defaultValues?.value
                ? 1
                : 2
              : defaultValues?.value,
        }
      : {},
  });

  const [focusedIndex, setFocusedIndex] = useState(null);
  const [focusStates, setFocusStates] = useState({});
  const [displayPrice, setDisplayPrice] = useState(0);

  const onChangePrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9.]/g, "");
      setDisplayPrice(formatNumberUS(Number(numericValue)));
      setValue("value", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatNumberUS]
  );

  useEffect(() => {
    reset(
      defaultValues?.type === "CHECKED"
        ? { value: defaultValues?.value ? 1 : 2 }
        : { value: defaultValues?.value ?? "" }
    );

    if (defaultValues?.value && defaultValues?.key === "amountHeld") {
      setDisplayPrice(formatNumberUS(defaultValues?.value || 0));
    } else if (defaultValues?.value && defaultValues?.type === "CHECKED") {
      setValue("value", defaultValues?.value ? 1 : 2);
    } else {
      setDisplayPrice(formatNumberUS(0));
    }
  }, [isOpen]);

  const handleFocus = (field, index) => {
    if (index !== null) {
      setFocusedIndex(index);
    } else {
      setFocusStates((prev) => ({ ...prev, [field]: true }));
    }
  };

  const handleBlur = (field, index) => {
    if (index !== null) {
      setFocusedIndex(index);
    } else {
      setFocusedIndex(null);
    }
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const onchangeCCMG = (option) => {
    setValue("value", option);
  };

  const submitHandler = (data) => {
    if (defaultValues?.id) {
      data.employeeId = defaultValues?.id;
    }

    if (defaultValues?.key) {
      data.key = defaultValues?.key;
    }

    if (defaultValues?.type === "CHECKED") {
      data.value = data.value === 1 ? true : false;
    }
    console.log(data);
    onSubmit(data);
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Box
            // paddingBottom={"80px"}
            w={"100%"}
            overflowY={"scroll"}
          >
            <Flex
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
              borderBottom={"1px solid var(--border-input-employee)"}
            >
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Chỉnh sửa dữ liệu
              </Text>
              <Box
                position={"absolute"}
                top={"24px"}
                right={"24px"}
                cursor={"pointer"}
                onClick={onClose}
              >
                <Image src={IconX} />
              </Box>
            </Flex>
            <Box margin={"0 auto"}>
              <Box flex={1} p={"24px 24px 40px 40px"}>
                {defaultValues?.type === "NUMBER" &&
                  defaultValues?.key === "amountHeld" && (
                    <InputControl
                      // type="number"
                      label="Tổng số quỹ giữ"
                      placeholder="Nhập tổng số quỹ còn giữ"
                      errors={errors.value}
                      register={register("value")}
                      onFocus={() => handleFocus("value")}
                      onBlur={() => handleBlur("value")}
                      state={focusStates["value"]}
                      onChange={onChangePrice}
                      value={displayPrice}
                      mwidth={"100%"}
                      // isRequired={true}
                    />
                  )}

                {defaultValues?.type === "NUMBER" &&
                  defaultValues?.key === "workingDays" && (
                    <InputControl
                      type="number"
                      label="Số công"
                      placeholder="Nhập số công"
                      errors={errors.value}
                      register={register("value")}
                      onFocus={() => handleFocus("value")}
                      onBlur={() => handleBlur("value")}
                      state={focusStates["value"]}
                      value={watch("value")}
                      mwidth={"100%"}
                      // isRequired={true}
                    />
                  )}

                {defaultValues?.type === "CHECKED" &&
                  defaultValues?.key === "isBrokerDebtCertificate" && (
                    <SelectControl
                      label="Đã có CCMG"
                      dataOption={CCMGData}
                      selectedMain={watch("value")}
                      placeholder="Chọn trạng thái CCMG"
                      onChange={onchangeCCMG}
                      onFocus={() => handleFocus("value")}
                      onBlur={() => handleBlur("value")}
                      state={focusStates["value"]}
                      registerProps={register("value")}
                      mwidth={"100%"}
                    />
                  )}
              </Box>
            </Box>
            <Box
              // position={"absolute"}
              w={"100%"}
              // bottom={"0"}
              bg={"var(--color-main)"}
              borderTop={"0.5px solid var(--bg-line-employee)"}
              borderRadius={"0px 0px 16px 16px"}
              zIndex={3}
            >
              <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                <Button
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-option-employee-hover)"}
                  borderRadius={"8px"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  onClick={onClose}
                >
                  Hủy
                </Button>
                <Button
                  type="submit"
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  bg={"var(--color-option-employee-hover)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Lưu
                </Button>
              </Flex>
            </Box>
          </Box>
        </form>
      </ModalContent>
    </Modal>
  );
});
